export const orderSubtableColumnWidths = {
  product: "11rem",
  lot: "7rem",
  serial: "6rem",
  weight: "5.5rem",
  pieces: "4.5rem",
  unitPrice: "5rem",
  subtotal: "5.5rem",
  tax: "5.5rem",
  taxRates: "7rem",
  unitType: "5rem",
  splits: "4.5rem",
  editor: "4.5rem",
};

export const orderSubtableSplitLabelColSpan = 4;
